<div class="responsive-label-container" #container>
  <svg #svgElement preserveAspectRatio="xMidYMid meet" class="responsive-label-svg">
    <text
      #textElement
      class="responsive-label-text"
      [attr.class]="customClass"
      dominant-baseline="middle"
      text-anchor="middle"
    >
      {{ text }}
    </text>
  </svg>
</div>
